<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <dr-image-component
      v-bind="$props"
      :class="evaluateClasses(classes)"
    ></dr-image-component>
  </dr-wrapper>
  <dr-image-component
    v-else-if="isVisible"
    v-bind="$props"
    :class="evaluateClasses(classes)"
  ></dr-image-component>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'
import drImageComponent from './dr-image-component'

export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  components: {
    drImageComponent
  }
}
</script>

<style>
</style>
